import auditTrailAPI from '@/app/apis/main/audit-trail/audit-trail-api.js';

export default {
    /**
	 * @return {object} audit trail list
	 * @param {*} auditTrailDetails - Contains pagination data
	 */
	async getAuditTrailList(auditTrailDetails) {
		return auditTrailAPI.getAuditTrailList(auditTrailDetails);
	},
	
    /**
	 * @return {object} audit trail action list
	 */
	async getAuditTrailActionList() {
		return auditTrailAPI.getAuditTrailActionList();
    },
	
    /**
	 * @return {object} audit trail changes
	 * @param {*} auditTrailId
	 */
	async getAuditTrailChanges(auditTrailId) {
		return auditTrailAPI.getAuditTrailChanges(auditTrailId);
    },
}